module.exports = __webpack_public_path__ + "static/media/site.25b9aa3d.jpg";